import { IApplicationLeaseQuote } from '../Interfaces/Application/IApplicationLeaseQuote';
import { ILeaseFee } from '../Interfaces/Common/ILeaseFee';

export type LeaseCustomFeeField = 'customFee1' | 'customFee2' | 'customFee3';

export interface LeaseCustomFee {
  description: string;
  fieldName: LeaseCustomFeeField;
}

const FIELDS: LeaseCustomFeeField[] = ['customFee1', 'customFee2', 'customFee3'];

/**
 * The custom fees in customFee1-3, named by the fees the quoter recorded when it filled them, or, for quotes filled
 * before it recorded them, by the loan class's non-standard fees in sort order 1-3 (the server's
 * LeaseFeeDescriptions.CustomFees). Slots with no fee are left out.
 */
export const getLeaseCustomFees = (quote: IApplicationLeaseQuote, loanClassFees: ILeaseFee[]): LeaseCustomFee[] => {
  const recorded = [quote.customFee1Description, quote.customFee2Description, quote.customFee3Description];
  const names = recorded.some(name => !!name?.trim())
    ? recorded
    : [1, 2, 3].map(sortOrder => loanClassFees.find(fee => !fee.standardFee && fee.sortOrder === sortOrder)?.description);

  return FIELDS
    .map((fieldName, index) => ({ description: names[index]?.trim() ?? '', fieldName }))
    .filter(fee => !!fee.description);
};
